export default __webpack_public_path__ + "53debf49500b561ac63a1f515c25763a.png";